import { SLAConfigSaveUpdate } from '../types/slaType.type'
import axiosInstance from '../utils/axiosInstance'
import { API_END_POINT } from '../utils/environment'
const getSlaEntities = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_END_POINT.CORE}sla/getEntitiesTypeStatus`
    )
    return response.data
  } catch (error) {
    console.error('errors', error)
  }
}

const saveSlaEntities = async (payload: SLAConfigSaveUpdate) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}v1/sla`,
    payload
  )
}

const updateSlaEntities = async (payload: SLAConfigSaveUpdate) => {
  return await axiosInstance.put(
    `${API_END_POINT.CORE}v1/sla`,
    payload
  )
}


const fetchSLA = async (payload: { id: string }) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}v1/sla/${payload.id}`
  )
}

const toggleSLA = async (id: string, enabled: boolean) => {
  return await axiosInstance.patch(
    `${API_END_POINT.CORE}v1/sla/${id}?enable=${!enabled}`
  )
}
const deleteSLA = async (slaId: number) => {
  return await axiosInstance.delete(`${API_END_POINT.CORE}v1/sla/${slaId}`)
}

// TODO: used later
// const fetchTypeForCase = async (targetEntityId: string) => {
//   return await axiosInstance.post(
//     `${API_END_POINT.ENTITY_MANAGER_V3}entity-data/get/case_type`,
//     {
//       entity_id: targetEntityId,
//       page: 0,
//       size: 10,
//       filters: [
//         {
//           logical_operator: 'AND',
//           criteria: [],
//         },
//         {
//           criteria: [
//             {
//               direction: 'ASC',
//               field_name: 'record_status',
//             },
//           ],
//         },
//       ],
//       select: ['id', 'name'],
//     }
//   )
// }

const fetchTypeForCase = async (targetEntityId: string) => {
  return await axiosInstance.get(
        `${API_END_POINT.CORE}programs/${targetEntityId}/services`,
  )
}
// TODO: used later
// const fetchStatusForCases = async (typeId: string) => {
//   return await axiosInstance.get(
//     `${API_END_POINT.LAYOUT_MANAGER}entity-tree/${typeId}`,
//     { params: { path: 'case_types.case_statuses', embedded: 'name' } }
//   )
// }

const fetchStatusForCases = async (typeId: string) => {
  return await axiosInstance.get(`${API_END_POINT.CORE}v1/sla/service-case-status`,
    { params: { serviceId: typeId } }
  )
}

const fetchTypeStatusForCommunications =async(type: string)=>{
  return await axiosInstance.get(`${API_END_POINT.ENTITY_MANAGER}category-value/type?categoryType=${type}`)
}

export { getSlaEntities, saveSlaEntities, fetchSLA, toggleSLA, deleteSLA, fetchStatusForCases, fetchTypeForCase, updateSlaEntities, fetchTypeStatusForCommunications}
